export function KeyStrokeTextDecorator({ children }) {
  return (
    <span className="font-normal bg-gray-500 text-white px-1 py-0.5 rounded-md">
      {children}
    </span>
  );
}
